export default "__VITE_ASSET__1d278658__"